import React from 'react';

import { NeuronImage } from '~shared/ui/atoms';
import { ButtonSecondary } from '~shared/ui/molecules';

import PictureIcon from '../../../../../../public/img/sexting-pack/picture.svg';
import { ButtonsContainer } from './styles';

type TProps = {
	itemsLength: number;
	showPaid: boolean;
	cost: number;
	onOpenPack: () => void;
	onUnlockPack: () => void;
};

export const SextingPackActions = ({
	itemsLength,
	showPaid,
	cost,
	onOpenPack,
	onUnlockPack,
}: TProps) => {
	return (
		<ButtonsContainer>
			<ButtonSecondary
				text={`${itemsLength}`}
				size="medium"
				iconLeft={<PictureIcon />}
				onClick={onOpenPack}
			/>

			{showPaid ? (
				<ButtonSecondary
					text={`Unlock all for ${cost}`}
					size="medium"
					onClick={onUnlockPack}
				>
					<NeuronImage size={24} />
				</ButtonSecondary>
			) : (
				<ButtonSecondary text="Open Media" size="medium" onClick={onOpenPack} />
			)}
		</ButtonsContainer>
	);
};
